import React from 'react';
import { Input as RoccoInput } from '@rocco/components/input';
import type { FilterConfigModalItemSimpleRange } from '@rocco/ui/filter-sort/types/filter-config-modal';
import type { RangeFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/range-filter-state';
import type { FilterModalElementProps } from '@rocco/ui/filter-sort/components/filters-modal/FiltersModalElement';

export const FiltersModalSimpleRange = (
    props: FilterModalElementProps<
        FilterConfigModalItemSimpleRange,
        RangeFilterState
    >,
) => {
    const { filterConfigItem, filterState, onFilterStateUpdate } = props;

    if (filterState.range.min === 0 && filterState.range.max === 0) {
        return null;
    }

    const updateRangeChange = (min: number, max: number) => {
        onFilterStateUpdate(
            {
                ...filterState,
                value: {
                    min: Math.min(
                        Math.max(filterState.range.min, min),
                        filterState.range.max,
                    ),
                    max: Math.max(
                        Math.min(filterState.range.max, max),
                        filterState.range.min,
                    ),
                },
            },
            false,
        );
    };

    const applyRangeChange = () => {
        onFilterStateUpdate({ ...filterState }, true);
    };

    return (
        <div className="flex flex-wrap items-center justify-between gap-2 pt-2">
            {filterConfigItem.label ? (
                <span className="font-medium min-w-16">
                    {filterConfigItem.label}
                </span>
            ) : null}

            <div className="flex flex-wrap gap-1.5">
                <div className="grow w-[6.875rem]">
                    <RoccoInput
                        type="text"
                        placeholder={filterConfigItem.minPlaceholder}
                        color="blackOutline"
                        focus="bordered"
                        value={
                            (filterState.value.min ?? 0) /
                            filterState.rangeDivisor
                        }
                        onChange={e =>
                            updateRangeChange(
                                Number(
                                    e.currentTarget.value.replace(
                                        /[^0-9]/g,
                                        '',
                                    ) || '0',
                                ) * filterState.rangeDivisor,
                                filterState.value.max ?? 0,
                            )
                        }
                        onBlur={applyRangeChange}
                    />
                </div>

                <div className="flex items-center justify-center">
                    <div className="h-px w-1.5 bg-gray-900" />
                </div>

                <div className="grow w-[6.875rem]">
                    <RoccoInput
                        type="text"
                        placeholder={filterConfigItem.maxPlaceholder}
                        color="blackOutline"
                        focus="bordered"
                        value={
                            (filterState.value.max ?? 0) /
                            filterState.rangeDivisor
                        }
                        onChange={e =>
                            updateRangeChange(
                                filterState.value.min ?? 0,
                                Number(
                                    e.currentTarget.value.replace(
                                        /[^0-9]/g,
                                        '',
                                    ) || '0',
                                ) * filterState.rangeDivisor,
                            )
                        }
                        onBlur={applyRangeChange}
                    />
                </div>
            </div>
        </div>
    );
};
